import React, { memo } from 'react';
import { useAppSelector } from 'store/hooks';
import WalkthroughContent from '../WalkthroughContent';
import { WalkthroughContext } from './context';
const Walkthrough = ({ isInTab, itemPositions, scrollRef, scrollHeight, scrollLayoutHeight, isFixedPosition, }) => {
    const status = useAppSelector((store) => store.feed.walkthrough?.status);
    if (status !== 'in-progress') {
        return null;
    }
    return (<WalkthroughContext.Provider value>
      <WalkthroughContent isInTab={isInTab} scrollRef={scrollRef} scrollHeight={scrollHeight} itemPositions={itemPositions} isFixedPosition={isFixedPosition} scrollLayoutHeight={scrollLayoutHeight}/>
    </WalkthroughContext.Provider>);
};
export default memo(Walkthrough);
